export const pageBreadcrumbs = {
  '/get-started': [
    { name: 'Home', path: '/' },
    { name: 'Get Started', path: '/get-started' }
  ],
  '/services/website-management': [
    { name: 'Home', path: '/' },
    { name: 'Services', path: '/services' },
    { name: 'Website Management', path: '/services/website-management' }
  ],
  '/services/technical-support': [
    { name: 'Home', path: '/' },
    { name: 'Services', path: '/services' },
    { name: 'Technical Support', path: '/services/technical-support' }
  ],
  '/services/business-email': [
    { name: 'Home', path: '/' },
    { name: 'Services', path: '/services' },
    { name: 'Business Email', path: '/services/business-email' }
  ],
  '/services/managed-hosting': [
    { name: 'Home', path: '/' },
    { name: 'Services', path: '/services' },
    { name: 'Managed Hosting', path: '/services/managed-hosting' }
  ],
  '/services/web-design-and-development': [
    { name: 'Home', path: '/' },
    { name: 'Services', path: '/services' },
    { name: 'Web Design and Development', path: '/services/web-design-and-development' }
  ],
  '/services/technology-consulting': [
    { name: 'Home', path: '/' },
    { name: 'Services', path: '/services' },
    { name: 'Technology Consulting', path: '/services/technology-consulting' }
  ],
  '/agency-services/white-label-wordpress': [
    { name: 'Home', path: '/' },
    { name: 'Agency Services', path: '/agency-services' },
    { name: 'White-Label WordPress', path: '/agency-services/white-label-wordpress' }
  ],
  '/agency-services/white-label-support': [
    { name: 'Home', path: '/' },
    { name: 'Agency Services', path: '/agency-services' },
    { name: 'White-Label Support', path: '/agency-services/white-label-support' }
  ],
  '/agency-services/agency-hosting': [
    { name: 'Home', path: '/' },
    { name: 'Agency Services', path: '/agency-services' },
    { name: 'Agency Hosting', path: '/agency-services/agency-hosting' }
  ],
  '/agency-plans': [
    { name: 'Home', path: '/' },
    { name: 'Agency Services', path: '/agency-services' },
    { name: 'Agency Plans', path: '/agency-plans' }
  ]
};
